const collator = new Intl.Collator('zh-Hans-CN-u-co-pinyin', { sensitivity: 'base', numeric: true });
const initials = [
  ['A', '阿'], ['B', '八'], ['C', '擦'], ['D', '搭'], ['E', '蛾'], ['F', '发'], ['G', '嘎'], ['H', '哈'],
  ['J', '击'], ['K', '喀'], ['L', '垃'], ['M', '妈'], ['N', '拿'], ['O', '哦'], ['P', '啪'], ['Q', '期'],
  ['R', '然'], ['S', '撒'], ['T', '塌'], ['W', '挖'], ['X', '昔'], ['Y', '压'], ['Z', '匝'],
];
export const memberName = member => member.user.nickname || member.user.username || '已注销用户';
export const memberInitial = name => {
  const first = [...name.trim().normalize('NFKD')][0] || '';
  if (/^[a-z]$/i.test(first)) return first.toUpperCase();
  if (!/^\p{Script=Han}$/u.test(first)) return '#';
  // 拼音排序用于目录定位；多音字沿用浏览器的默认读音。
  return initials.reduce((key, [letter, boundary]) => collator.compare(first, boundary) >= 0 ? letter : key, '#');
};
export const groupMembers = (members, separateOwners = true) => {
  const grouped = new Map();
  [...members].sort((a, b) => collator.compare(memberName(a), memberName(b))).forEach(member => {
    const key = separateOwners && member.role === 'owner' ? 'owner' : memberInitial(memberName(member));
    if (!grouped.has(key)) grouped.set(key, []);
    grouped.get(key).push(member);
  });
  return [...grouped.entries()].sort(([a], [b]) => {
    const rank = key => key === 'owner' ? -1 : key === '#' ? 100 : key.charCodeAt(0);
    return rank(a) - rank(b);
  }).map(([key, items]) => ({ key, label: key === 'owner' ? '群主' : key === '#' ? '其他' : key, items }));
};
